import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=5b001f69&"
import script from "./ModuleCard.vue?vue&type=script&lang=ts&"
export * from "./ModuleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VResponsive,VSheet})
